import { Controller } from 'stimulus'
import { put } from '@rails/request.js'

export default class extends Controller {
  static targets = ['showLabelsCheckbox', 'showIssuesCheckbox', 'showTopicsCheckbox', 'loadingComponent']

  showLabelsEventName = 'search-v2--search-result-item#showLabels'
  hideLabelsEventName = 'search-v2--search-result-item#hideLabels'
  showIssuesEventName = 'search-v2--search-result-item#showIssues'
  hideIssuesEventName = 'search-v2--search-result-item#hideIssues'
  showTopicsEventName = 'search-v2--search-result-item#showTopics'
  hideTopicsEventName = 'search-v2--search-result-item#hideTopics'

  sendToggleLabelsEvent(event) {
    if (this.shouldDisplayLabels) {
      this.sendEvent(this.showLabelsEventName)
    } else {
      this.sendEvent(this.hideLabelsEventName)
    }
    this.updateUserCheckboxPreferences()
  }

  sendToggleIssuesEvent(event) {
    if (this.shouldDisplayIssues) {
      this.sendEvent(this.showIssuesEventName)
    } else {
      this.sendEvent(this.hideIssuesEventName)
    }
    this.updateUserCheckboxPreferences()
  }

  sendToggleTopicsEvent(event) {
    if (this.shouldDisplayTopics) {
      this.sendEvent(this.showTopicsEventName)
    } else {
      this.sendEvent(this.hideTopicsEventName)
    }
    this.updateUserCheckboxPreferences()
  }

  sendEvent(name) {
    const event = new CustomEvent(name, { bubbles: true })
    document.dispatchEvent(event)
  }

  async updateUserCheckboxPreferences() {
    this.loadingComponentTarget.classList.remove('hidden')

    const response = await put('/user_default', {
      body: {
        user_default: {
          directory_show_issues: this.shouldDisplayIssues,
          directory_show_labels: this.shouldDisplayLabels,
          directory_show_topics: this.shouldDisplayTopics
        }
      },
      contentType: 'application/json'
    })
    if (!response.ok) {
      console.error('The PUT to user_default failed.')
    }

    this.loadingComponentTarget.classList.add('hidden')
  }

  get shouldDisplayLabels() {
    return this.showLabelsCheckboxTarget.checked
  }

  get shouldDisplayIssues() {
    return this.showIssuesCheckboxTarget.checked
  }

  get shouldDisplayTopics() {
    return this.showTopicsCheckboxTarget.checked
  }
}
